const SET_DOWN_PAYMENT = 'SET_DOWN_PAYMENT';
const SET_LOAN_TERM = 'SET_LOAN_TERM';
const SET_LOAN_INTEREST = 'SET_LOAN_INTEREST';
const SET_MOSAIC_TERM = 'SET_MOSAIC_TERM';
const SET_MOSAIC_DOWN_PAYMENT = 'SET_MOSAIC_DOWN_PAYMENT';
const SET_LOAN_PROVIDER = 'SET_LOAN_PROVIDER';
const SET_SHOW_LOAN = 'SET_SHOW_LOAN';
const SET_LOAN = 'SET_LOAN';

export {
    SET_DOWN_PAYMENT,
    SET_LOAN_TERM,
    SET_LOAN_INTEREST,
    SET_MOSAIC_TERM,
    SET_MOSAIC_DOWN_PAYMENT,
    SET_LOAN_PROVIDER,
    SET_SHOW_LOAN,
    SET_LOAN,
};



// WEBPACK FOOTER //
// ./src/containers/common/loan/constants.js